import React, { useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { RichText } from './RichText';
import { faqs } from '../../data/landing';
export function Faq() {
  const [open, setOpen] = useState<number | null>(null);
  const reduce = useReducedMotion();
  return <section id="preguntas" aria-labelledby="faq-title" className="scroll-mt-16 bg-paper py-16 md:py-24" data-id="element-64" data-mp="3qu3m2s8mfvl9">
      <div className="mx-auto max-w-3xl px-5" data-id="element-65" data-mp="3luqwhzqd8aez">
        <SectionHeading id="faq-title" title="Preguntas frecuentes" data-id="element-66" data-mp="3ltz2gtcf2kqt" />
        <ul className="mt-12 space-y-3" data-id="element-67" data-mp="3gx8k1zd53d28">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <li key={faq.question} className="rounded-2xl border border-line bg-cream" data-id="element-68" data-mp="3bz75nrqns1x3" data-mpi={i}>
                <h3 data-id="element-69" data-mp="1f416ovh375iz">
                  <button type="button" aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} id={`faq-button-${i}`} onClick={() => setOpen(isOpen ? null : i)} className="flex w-full items-center justify-between gap-4 rounded-2xl px-6 py-5 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-primary" data-id="element-70" data-mp="1a5pysqacr53e">
                    <span className="font-serif text-lg leading-snug text-ink" data-id="element-71" data-mp="17rn64f8pb5vr">{faq.question}</span>
                    <PlusIcon className={`h-5 w-5 shrink-0 text-ink transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-72" data-mp="1vh7s7705ij99" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-73" data-mp="1qp7k2r9xgk1l">
                  {isOpen && <motion.div id={`faq-panel-${i}`} role="region" aria-labelledby={`faq-button-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: reduce ? 0 : 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-74" data-mp="2ef1wx8u8y8lu">
                      <p className="px-6 pb-6 text-[16px] leading-relaxed text-muted" data-id="element-75" data-mp="2f3am79rfgd5c">
                        <RichText text={faq.answer} data-id="element-76" data-mp="2a3y412bi3u93" />
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}